import { render } from "./CommentModal.vue?vue&type=template&id=20d879a5"
import script from "./CommentModal.vue?vue&type=script&lang=js"
export * from "./CommentModal.vue?vue&type=script&lang=js"

const cssModules = {}
import style0 from "./CommentModal.vue?vue&type=style&index=0&id=20d879a5&lang=scss&module=true"
cssModules["$style"] = style0

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__cssModules',cssModules]])

export default __exports__